// extracted by mini-css-extract-plugin
export default {"div":"Input_div__fcicX","bold":"Input_bold__bgAAx"};